module.exports = __webpack_public_path__ + "assets/media/day15.83fd2e00.mp3";